import { TermInterestAmountOverride } from "./TermInterestAmountOverride";
import dayjs from "dayjs";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import isBetween from "dayjs/plugin/isBetween";
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.extend(isBetween);
export class TermInterestAmountOverrides {
    _overrides = [];
    constructor(overrides = []) {
        this.overrides = overrides;
        this.updateJsValues();
    }
    updateModelValues() {
        this._overrides.forEach((bm) => bm.updateModelValues());
    }
    updateJsValues() {
        this._overrides.forEach((bm) => bm.updateJsValues());
    }
    get overrides() {
        return this._overrides;
    }
    set overrides(value) {
        // check type and inflate if necessary
        this._overrides = value.map((c) => {
            if (c instanceof TermInterestAmountOverride) {
                return c;
            }
            return new TermInterestAmountOverride(c);
        });
    }
    get all() {
        return this._overrides;
    }
    get active() {
        return this._overrides.filter((bm) => bm.active === true);
    }
    deactivateAll() {
        this._overrides.forEach((bm) => (bm.active = false));
    }
    activateAll() {
        this._overrides.forEach((bm) => (bm.active = true));
    }
    addOverride(override) {
        this._overrides.push(override);
    }
    removeOverrideAtIndex(index) {
        this._overrides.splice(index, 1);
    }
    removeAllOverrides() {
        this._overrides = [];
    }
    get length() {
        return this._overrides.length;
    }
    atIndex(index) {
        return this._overrides[index];
    }
    get first() {
        return this._overrides[0];
    }
    get last() {
        return this._overrides[this._overrides.length - 1];
    }
    get json() {
        return this._overrides.map((bm) => bm.json);
    }
    toJSON() {
        return this.json;
    }
    isDuplicateTermNumber(termNumber) {
        // detect if there are more than one override for the same term number
        return this._overrides.filter((bm) => bm.termNumber === termNumber).length > 1;
    }
    reSort() {
        this.updateModelValues();
        this._overrides = this._overrides.sort((a, b) => {
            return a.termNumber - b.termNumber;
        });
        this.updateJsValues();
    }
}
